<!--
 * @Description: 申请开票-开票信息
 * @Date: 2025-05-20 15:57:04
-->
<template>
  <BaseForm
    ref="formRef"
    label-position="top"
    scrollToError
    :model="info"
    :rules="infoRules"
  >
    <div class="form-dialog__title">
      <h1>开票信息</h1>
    </div>
    <div class="form-dialog__content">
      <BaseFormItem label="企业名称" prop="entpName">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="baseInfo.entpName"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="纳税识别号" prop="entpCertNo">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="baseInfo.entpCertNo"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="联系电话" prop="phone">
        <BaseInput
          class="form-dialog__w280"
          type="tel"
          placeholder="请输入"
          disabled
          :modelValue="baseInfo.phone"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="开户银行" prop="bankName">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="baseInfo.bankName"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="银行账号" prop="openBankNumber">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="baseInfo.openBankNumber"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="企业地址" prop="companyBusinessAddress">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="baseInfo.companyBusinessAddress"
        ></BaseInput>
      </BaseFormItem>
    </div>
  </BaseForm>
</template>

<script lang="tsx" setup>
import {
  withDefaults,
  defineProps,
  ref,
  defineExpose,
  // defineModel,
  watch
} from 'vue';
import { BaseForm, BaseFormItem, BaseInput } from 'xrk-components';
import {
  BasicInformationData
  // MakeOutAnInvoiceParams
} from '@V/invoice/src/data-source/types';

type BaseInfo = BasicInformationData['baseInfo'];

const props = withDefaults(
  defineProps<{
    baseInfo: BaseInfo;
    disabled: boolean;
  }>(),
  {}
);

const formRef = ref(null);
// const formData = defineModel<MakeOutAnInvoiceParams>();
const info = ref<BaseInfo>({
  entpName: '',
  entpCertNo: '',
  phone: '',
  bankName: '',
  openBankNumber: '',
  companyBusinessAddress: '',
  demand: ''
});
const infoRules = {
  entpName: [{ required: true, message: '', trigger: 'blur' }],
  entpCertNo: [{ required: true, message: '', trigger: 'blur' }],
  phone: [{ required: true, message: '', trigger: 'blur' }],
  bankName: [{ required: true, message: '', trigger: 'blur' }],
  openBankNumber: [{ required: true, message: '', trigger: 'blur' }],
  companyBusinessAddress: [{ required: true, message: '', trigger: 'blur' }]
};
watch(
  () => props.baseInfo,
  v => {
    info.value = v;
  }
);

defineExpose({
  validate: (...args: any) => formRef.value?.validate(...args)
});
</script>
